import { useState } from 'react';
import { Icon } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import CreditRatingModal from '@app/components/popups/CreditRatingModal';
import formatAmount from '@modules/calculator/utils/formatAmount';
import calculateMonthlyLiabilities from '@modules/investor/utils/calculateMonthlyLiabilities';
import DetailSection from './DetailSection';
const MainDetails = ({ details }) => {
    const { t } = useTranslation();
    const [isCreditRatingModalOpen, setIsCreditRatingModalOpen] = useState(false);
    const creditScoreLabel = (<button type="button" onClick={() => setIsCreditRatingModalOpen(true)} className="text-gray-400 hover:text-gray-600 cursor-pointer" aria-label={t('financing.credit_rating.modal_title')}>
            <Icon name="info_filled" size="sm"/>
        </button>);
    const loanDetails = [
        { label: t('financing.investment_details.amount'), value: details ? formatAmount(details.amount) : '' },
        {
            label: t('financing.investment_details.period'),
            value: details ? `${details.period} ${t('financing.investing_page_table.months')}` : '',
        },
        { label: t('financing.investment_details.purpose'), value: (details === null || details === void 0 ? void 0 : details.purpose) ? details.purpose : '' },
        {
            label: t('financing.investment_details.credit_score'),
            labelComponent: creditScoreLabel,
            value: details ? details.riskLevel : '',
        },
        {
            label: t('financing.investment_details.personal_use'),
            value: details ? t('financing.investment_details.yes') : '',
        },
        {
            label: t('financing.investment_details.direct_beneficiary'),
            value: details ? t('financing.investment_details.borrower') : '',
        },
    ];
    const incomeDetails = [
        {
            label: t('financing.investment_details.monthly_income'),
            value: details ? formatAmount(details.avgIncome) : '',
        },
        {
            label: t('financing.investment_details.income_period'),
            value: (details === null || details === void 0 ? void 0 : details.periodOfIncome) ? details.periodOfIncome : '',
        },
        {
            label: t('financing.investment_details.income_sources'),
            value: (details === null || details === void 0 ? void 0 : details.incomeSource) ? details.incomeSource.split('+').join(', ') : '',
        },
        {
            label: t('financing.investment_details.income_change'),
            value: (details === null || details === void 0 ? void 0 : details.incomeChange) ? details.incomeChange : '',
        },
    ];
    const liabilityDetails = [
        {
            label: t('financing.investment_details.living_place'),
            value: (details === null || details === void 0 ? void 0 : details.livingEstate) ? details.livingEstate : '',
        },
        {
            label: t('financing.investment_details.total_debts'),
            value: details ? formatAmount(details.forRealEstateCreditsAmount + details.forConsumerCreditsAmount) : '',
        },
        {
            label: t('financing.investment_details.monthly_obligations'),
            value: details ? formatAmount(details.forOtherObligations) : '',
        },
        {
            label: t('financing.investment_details.monthly_liabilities'),
            value: details ? `${calculateMonthlyLiabilities(details)}%` : '',
        },
        {
            label: t('financing.investment_details.planned_debts'),
            value: details ? formatAmount(details.liabilityPlanningAmount) : '',
        },
        {
            label: t('financing.investment_details.dependants'),
            value: (details === null || details === void 0 ? void 0 : details.numberOfDependents) ? details.numberOfDependents : '',
        },
    ];
    return (<>
            <DetailSection title={t('financing.investment_details.loan')} items={loanDetails}/>
            <DetailSection title={t('financing.investment_details.borrower_income')} items={incomeDetails}/>
            <DetailSection title={t('financing.investment_details.borrower_liabilities')} items={liabilityDetails}/>
            <CreditRatingModal isOpen={isCreditRatingModalOpen} closeModal={() => setIsCreditRatingModalOpen(false)}/>
        </>);
};
export default MainDetails;
